var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60012 5.5C9.75371 5.5 9.9073 5.57622 10.0243 5.72789L14.8241 11.95C15.0586 12.2541 15.0586 12.7457 14.8241 13.0498L10.0243 19.2719C9.78971 19.576 9.41053 19.576 9.17594 19.2719C8.94135 18.9678 8.94135 18.4763 9.17594 18.1722L13.5515 12.4999L9.17594 6.82765C8.94135 6.52354 8.94135 6.03199 9.17594 5.72789C9.29293 5.57622 9.44653 5.5 9.60012 5.5Z",
    fill: "#95959D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.5320d09e1999eb04900008ab192a3834.svg";
export { ForwardRef as ReactComponent };